import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { ServerUrls } from '~src/commonInfra/url/ServerUrls';

import { PackageDetailsSubspace } from './PackageDetailsSubspace';
import { PackagesSiteSection } from './PackagesSiteSection';

// Routes the Packages list vs. per-package detail. Mirrors ConnectedApplicationSubspaceRouter.
// The bare /settings route catches an Admin Profile holder whose only visible tab is Packages.
export function PackagesSubspaceRouter(): React.ReactElement {
  const siteUrls = siteUrlsSelector(getAppStore().getState());
  const serverUrls = ServerUrls.getInstance();
  return (
    <Switch>
      {siteUrls && (
        <Route exact path={siteUrls.packageDetailsPath(':luid')} render={({ match }) => (
          <PackageDetailsSubspace {...match} />
        )} />
      )}
      {siteUrls && (
        <Route exact path={siteUrls.settingsPackagesPath()} render={() => <PackagesSiteSection />} />
      )}
      <Route exact path={serverUrls.settingsPackagesPath()} render={() => <PackagesSiteSection />} />
      {siteUrls && (
        <Route exact path={siteUrls.settingsPath()} render={() => <PackagesSiteSection />} />
      )}
    </Switch>
  );
}
